<div class="documentation-container">
  <section class="leftbar">
    <app-filter-component
      [selectedMachine]="selectedMachine"
      [listOfMachinesFromApi]="listOfMachinesFromApi"
      [showDateFilter]="false"
      (selectedMachineChanged)="handleSelectedMachineChange($event)"
    >
    </app-filter-component>
  </section>

  <div *ngIf="selectedMachine; then contentBlock; else noSelectionBlock"></div>

  <ng-template #contentBlock>
    <section class="rightbar">
      <div class="documentation-content">
        <div class="documentation-section">
          <h2 class="section-title">
            <mat-icon class="section-icon">description</mat-icon>
            Documentazione per il cliente
          </h2>
          <mat-list class="file-list">
            <mat-list-item
              *ngFor="let file of customerDocumentationFiles"
              class="file-item"
              (click)="openFile(file)"
            >
              <div class="file-info">
                <span class="file-name">{{ file.name }}</span>
              </div>
              <mat-icon class="file-icon">{{ getFileIcon(file.fileType) }}</mat-icon>
            </mat-list-item>
          </mat-list>
        </div>

        <div class="documentation-section">
          <h2 class="section-title">
            <mat-icon class="section-icon">engineering</mat-icon>
            File tecnici ad uso interno o di supporto
          </h2>
          <mat-list class="file-list">
            <mat-list-item
              *ngFor="let file of internalDocumentationFiles"
              class="file-item"
              (click)="openFile(file)"
            >
              <div class="file-info">
                <span class="file-name">{{ file.name }}</span>
              </div>
              <mat-icon class="file-icon">{{ getFileIcon(file.fileType) }}</mat-icon>
            </mat-list-item>
          </mat-list>
        </div>
      </div>
    </section>
  </ng-template>

  <ng-template #noSelectionBlock>
    <section class="no-selection">
      <mat-card>
        <mat-card-content>
          Seleziona una macchina per visualizzare la documentazione disponibile.
        </mat-card-content>
      </mat-card>
    </section>
  </ng-template>
</div>
